let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let Electron = require("../../utils/Electron");
let ImageURLs = require("../../utils/ImageURLs");
let HoverMixin = require("ES/utils/HoverMixin");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let AuthedUserSession = require("../../utils/AuthedUserSession");
let Constants = require("../../utils/Constants");

let DropDownMenuItem = dd.createClass({
  mixins: [HoverMixin],
  getInitialState() {
    return { show_dd: false };
  },
  __toggleDropDown: esUtils.wrapPreventDefault(function () {
    this.setState({ show_dd: !this.state.show_dd });
    //TODO: hide any other open dropdown when a new one is opened
  }),
  hoverable_onUserLeftHoverable() {
    if (this.state.show_dd) {
      //only setState if needed
      this.setState({ show_dd: false });
    }
  },
  __itemClick(action) {
    let self = this;
    return function (e) {
      self.setState({ show_dd: !self.state.show_dd });
      if (_.isFunction(action)) {
        action(e);
      }
    };
  },
  __disableClick: esUtils.wrapPreventDefault(_.noop),
  render() {
    return dd.li(
      {
        className: "dropdown" + (this.state.show_dd ? " open" : ""),
        onMouseEnter: this.hoverable_onMouseEnter,
        onMouseLeave: this.hoverable_onMouseLeave,
      },
      dd.a(
        {
          href: "#",
          className: "dropdown-toggle",
          onClick: this.__toggleDropDown,
        },
        this.props.name,
        " ",
        dd.b({ className: "caret" })
      ),
      dd.ul(
        { className: "dropdown-menu", role: "menu" },
        _.map(
          _.filter(this.props.items),
          function (item, i) {
            if (item.divider) {
              return dd.li({ key: i, className: "divider" });
            }
            return dd.li(
              {
                key: i,
                role: "presentation",
                className: item.no_click ? "disabled" : null,
              },
              dd.a(
                {
                  role: "menuitem",
                  href: item.href || "#",
                  onClick: item.no_click
                    ? this.__disableClick
                    : this.__itemClick(item.onClick),
                },
                item.name
              )
            );
          },
          this
        )
      )
    );
  },
});

let Menu = dd.createClass({
  mixins: [RadioServiceMixin],
  getInitialState() {
    return {};
  },
  __showEventSearch: esUtils.wrapPreventDefault(function () {
    this.__toMainViewThenDoThis(function () {
      radio("EventSearchAside_open").broadcast();
    });
  }),
  __genCSPReport(sid) {
    return esUtils.wrapPreventDefault(function () {
      window
        .open(
          "/csp_application?speaker_id=" +
            sid +
            "&" +
            esUtils.phpCompatibleParams(AuthedUserSession.balboa),
          "CSPApplication",
          "height=600,width=1024"
        )
        .focus();
    });
  },
  __showEmpireCalendar: esUtils.wrapPreventDefault(function () {
    window
      .open(
        "/admin/token-callback/" +
          esUtils.phpCompatibleParams(AuthedUserSession.balboa) +
          "?redir=/empire-calendar",
        "esAdmin",
        "height=600,width=1024"
      )
      .focus();
  }),
  __showReports: esUtils.wrapPreventDefault(function () {
    window
      .open(
        "/reports/menu.phtml?" +
          esUtils.phpCompatibleParams(AuthedUserSession.balboa),
        "esReportWindow",
        "height=600,width=1024"
      )
      .focus();
  }),
  __showCRM(sid, url, crmkind) {
    let self = this;
    let CRMWindowName = _.get(
      Constants,
      [
        "GRAB_SERVICES_WITH_DEEP_INTEGRATION",
        crmkind.toUpperCase(),
        "browser_window_name",
      ],
      "genericcrm"
    );

    return esUtils.wrapPreventDefault(function () {
      if (
        _.get(
          self.props,
          "Displaylists.user.myevents_preferences.open_crm_in_same_window",
          false
        )
      ) {
        radio("Hashbang_set").broadcast("/crm/" + sid);
      } else {
        window.open(url, CRMWindowName, "height=700,width=1200").focus();
      }
    });
  },
  __showMonthCalendar: esUtils.wrapPreventDefault(function () {
    this.__toMainViewThenDoThis(function () {
      radio("Show_Calendar").broadcast("month");
    });
  }),
  __showYearCalendar: esUtils.wrapPreventDefault(function () {
    this.__toMainViewThenDoThis(function () {
      radio("Show_Calendar").broadcast("year");
    });
  }),
  __showDashboard: esUtils.wrapPreventDefault(function () {
    this.__toMainViewThenDoThis(function () {
      radio("Show_Calendar").broadcast("Dashboard");
    });
  }),
  __toMainViewThenDoThis(do_this) {
    radio("Hashbang_set").broadcast("/");
    setTimeout(do_this, 250);
  },
  render() {
    let { Displaylists } = this.props;
    let pro_sids = AuthedUserSession.getSIDsAtPackageLevel("PRO");
    let trav_or_read_only = AuthedUserSession.doIHaveAccess.read_or_travel.all(
      AuthedUserSession.all_sids_i_have_permissions_for
    );
    let dont_marketplace =
      trav_or_read_only || AuthedUserSession.is_privatelabel;
    let csp_links = [];
    let crm_sso_links = [];
    let canOnlyCreatePersonalEvent =
      AuthedUserSession.is_st_family &&
      !AuthedUserSession.doIHaveAccess.full.any(
        AuthedUserSession.all_sids_i_have_permissions_for
      ); //as for speaker users on a privatelabel who can only create blackout events

    if (!AuthedUserSession.is_privatelabel) {
      //CSP application
      csp_links = _.map(
        _.sortBy(Displaylists && Displaylists.perspeaker, function (spkr) {
          return _.get(spkr, "name_full", "(name unknown)")
            .toUpperCase()
            .trim();
        }),
        function (spkr) {
          if (!_.includes(pro_sids, spkr.sid)) {
            return {
              no_click: true,
              name:
                "CSP Progress report for " +
                _.get(spkr, "name_full", "(name unknown)") +
                " (Pro only)",
            };
          }
          return {
            onClick: this.__genCSPReport(spkr.sid),
            name:
              "CSP Progress Report for " +
              _.get(spkr, "name_full", "(name unknown)"),
          };
        },
        this
      );
    }

    //CRM single sign-on
    crm_sso_links = _.map(
      _.get(Displaylists, "perspeaker", []),
      function (spkr) {
        return _.map(
          _.get(spkr, "crm_sso", []),
          function (crm_sso) {
            return {
              onClick: this.__showCRM(
                _.get(spkr, "sid", 0),
                _.get(crm_sso, "sso_url", "#"),
                _.get(crm_sso, "kind")
              ),
              name:
                _.get(spkr, "name_full", "(name unknown)").trim() +
                " " +
                _.get(
                  Constants,
                  ["GRAB_SERVICES", _.get(crm_sso, "kind", "unknown")],
                  _.get(crm_sso, "kind", "unknown")
                ),
            };
          },
          this
        );
      },
      this
    );
    crm_sso_links = crm_sso_links.filter(function (el) {
      return !_.isEmpty(el);
    });
    crm_sso_links = _.flatten(crm_sso_links);

    let logout_uri = AuthedUserSession.is_st_family
      ? `https://us-east-1neqazvzhh.auth.us-east-1.amazoncognito.com/logout?client_id=63i9p9d7v7g41go9b3btmov09f&redirect_uri=${encodeURIComponent(
          `/balboa3/oauth2/invalidatetoken?redir=/myevents/signin?cognito`
        )}&logout_uri=${encodeURIComponent(
          `https://balboa-st.espeakers.com/speaker/connect/cognito/logout`
        )}`
      : "/balboa3/oauth2/invalidatetoken?redir=/dashboard/login";

    if (AuthedUserSession.is_staging && AuthedUserSession.is_st_family) {
      logout_uri = `https://us-east-1al1ir26l3.auth.us-east-1.amazoncognito.com/logout?client_id=52kr75ahdvkdb8vq3ojoanvq0c&redirect_uri=${encodeURIComponent(
        `/balboa3/oauth2/invalidatetoken?redir=/myevents/signin?cognito`
      )}&logout_uri=${encodeURIComponent(
        `https://balboa-st-staging.espeakers.com/speaker/connect/cognito/logout`
      )}`;
    }

    return dd.div(
      { className: "collapse navbar-collapse" },
      dd.ul(
        { className: "nav navbar-nav navbar-right" },

        //events
        trav_or_read_only
          ? null
          : DropDownMenuItem({
              name: "My Events",
              items: [
                { onClick: this.__showMonthCalendar, name: "Show Events" },
                { href: "#/events/new", name: "New Event" },
                { onClick: this.__showDashboard, name: "Dashboard" },
                { onClick: this.__showEventSearch, name: "Search Events" },
                { onClick: this.__showMonthCalendar, name: "Month Calendar" },
                { onClick: this.__showYearCalendar, name: "Year Calendar" },
                !AuthedUserSession.is_privatelabel
                  ? {
                      href: "#/events/import/hl",
                      name: "Import HighLevel Opportunity",
                    }
                  : null,
                !AuthedUserSession.is_privatelabel
                  ? {
                      href: "#/events/import/infusionsoft",
                      name: "Import Keap Opportunity",
                    }
                  : null,
                !AuthedUserSession.is_privatelabel
                  ? {
                      href: "#/events/import/zoho",
                      name: "Import SpeakerFlow/Zoho Opportunity",
                    }
                  : null,

                _.size(csp_links) > 0 ? { divider: true } : null,
              ].concat(csp_links),
            }),

        //reports
        trav_or_read_only || canOnlyCreatePersonalEvent
          ? null
          : dd.li(
              {},
              dd.a({ href: "#", onClick: this.__showReports }, "Reports")
            ),

        //marketplace
        dont_marketplace
          ? null
          : dd.li({}, dd.a({ href: "#/marketplace" }, "Marketplace")),

        //single speaker, with crm
        1 === crm_sso_links.length &&
          1 === _.get(Displaylists, "perspeaker", []).length
          ? dd.li(
              {},
              dd.a(
                {
                  href: "#",
                  onClick: _.get(crm_sso_links[0], "onClick"),
                },
                "CRM"
              )
            )
          : null,

        //multiple speakers, with crm
        _.get(Displaylists, "perspeaker", []).length > 1 &&
          !_.isEmpty(crm_sso_links)
          ? DropDownMenuItem({
              name: "CRM",
              items: crm_sso_links,
            })
          : null,

        //help
        dd.li(
          {},
          dd.a({ href: AuthedUserSession.helpurl, target: "_blank" }, "Help")
        ),

        //account
        DropDownMenuItem({
          name: dd.span(
            null,
            dd.i({ className: "fa fa-user" }),
            " ",
            AuthedUserSession.MY_USERNAME.toLowerCase().substring(0, 25)
          ),
          items: [
            {
              href: AuthedUserSession.is_st_family
                ? "/" // ST family users (both admin and speaker)
                : "/dashboard/token-callback?token=" +
                  _.get(AuthedUserSession, ["balboa", "estoken"], "") +
                  "&redir=/" +
                  AuthedUserSession.getLastSelectedSID(), // All other users
              name: "Account menu",
            },
            trav_or_read_only
              ? null
              : { href: "#/account_settings", name: "Settings" },
            { divider: true },
            Electron.is_on
              ? { href: Electron.logout_url, name: "Sign out" }
              : {
                  href: logout_uri,
                  name: "Sign out",
                },
            Electron.is_on
              ? {
                  onClick: esUtils.wrapPreventDefault(Electron.quit),
                  name: "Quit",
                }
              : null,
          ],
        })
      )
    );
  },
});

let UpdateAlert = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return { update_available: false };
  },
  Radio_setup() {
    return {
      NewAppVersionChecker_new_version_available() {
        this.setState({ update_available: true });
      },
    };
  },
  componentDidMount() {
    radio("NewAppVersionChecker_get_status").broadcast();
  },
  __reload: esUtils.wrapPreventDefault(function () {
    window.location.reload();
  }),
  render() {
    if (this.state.update_available) {
      return dd.div(
        {
          className: "alert alert-info pull-left",
          style: { margin: "6px 0 0 0", padding: "3px 10px" },
        },
        "New update available! ",
        dd.button(
          { className: "btn btn-default btn-sm", onClick: this.__reload },
          "reload"
        )
      );
    }
    return dd.div();
  },
});

module.exports = dd.createClass({
  __changeActiveCompany: function () {
    radio("change_active_company").broadcast();
  },
  render() {
    let { Displaylists } = this.props;
    let is_beta = AuthedUserSession.is_beta;
    let is_st_family = AuthedUserSession.is_st_family;
    let thestyle = { padding: "11px 11px 11px " + (is_beta ? "40px" : "11px") };
    if (AuthedUserSession.is_privatelabel) {
      thestyle.cursor = "pointer";
    }
    return dd.nav(
      {
        className: "HeadNavbar navbar navbar-default",
        style: { marginBottom: 0 },
      },
      dd.span(
        {
          onClick:
            AuthedUserSession.is_privatelabel && this.__changeActiveCompany,
          className: "navbar-brand",
          style: thestyle,
        },
        is_beta ? dd.span({ className: "beta-ribbon" }, "BETA") : null,
        dd.img({
          key: _.uniqueId(),
          src: ImageURLs.logo,
          style: { height: 28 },
        }),
        is_st_family
          ? dd.span(
              {
                className: "btn btn-link",
                style: {
                  fontSize: "0.75rem",
                  paddingTop: "0",
                  marginTop: "-1rem",
                },
              },
              "change"
            )
          : null
      ),
      UpdateAlert(),
      Menu({ Displaylists })
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/layout/HeadNavbar.js